import React from 'react';
import { DownloadOutlined, ArrowRightOutlined } from '@ant-design/icons';
import { Dictionary } from '../handbooks.types';

export interface CardProps {
    dictionary: Dictionary;
}

export const Row = ({ dictionary: { link, source, title } }: CardProps) => {
    return (
        <div
            className="handbooks-list-item"
            onClick={() => open(link, '_self')}
        >
            <span>{title}</span>
            <span className="icon-container">
                {source === 'ibd' ? <ArrowRightOutlined /> : <DownloadOutlined />}
            </span>
        </div>
    );
};
